import type { FC } from "react";
import { UserRoundCog } from "lucide-react";

import {
  useGetPatientInvitationCode,
  useSendPatientInvitation,
} from "@/api/patients";
import type { UpdateModalProps } from "@/components/modals/administrative-infos-update-modal";
import GenericModal from "@/components/modals/generic-modal";
import Loader from "@/components/ui/loader";

const InvitePatientModal: FC<UpdateModalProps> = ({
  open,
  setOpen,
  patient,
}) => {
  const { data: patientInviteCode, isLoading } = useGetPatientInvitationCode(
    patient.id
  );
  const { mutateAsync: sendInvitation, isPending } = useSendPatientInvitation();

  return (
    <GenericModal
      title={"Inviter un patient sur MyPerioApp"}
      logo={<UserRoundCog />}
      open={open}
      setOpen={setOpen}
      handleSubmit={async () => {
        await sendInvitation(patient.id, { onSuccess: () => setOpen(false) });
      }}
      isSubmitPending={isPending}
      submitLabel="Envoyer par email"
    >
      {isLoading ? (
        <Loader />
      ) : (
        <div className="flex flex-col gap-4 px-6">
          {
            "Voici le code à transmettre à votre patient pour son inscription sur MyPerioApp :"
          }
          <div>{patient.code ? patient.code : patientInviteCode?.code}</div>
        </div>
      )}
    </GenericModal>
  );
};

export default InvitePatientModal;
